/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';

interface HubspotContactFormProps {
  portalId: string;
  formId: string;
}

const HubspotContactForm = ({ portalId, formId }: HubspotContactFormProps) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/shell.js';
    document.body.appendChild(script);

    const addHubspotForm = () => {
      if ((window as any).hbspt) {
        (window as any).hbspt.forms.create({
          portalId,
          formId,
          target: '#hubspotForm',
        });
      }
    };

    script.addEventListener('load', addHubspotForm);

    return () => {
      script.removeEventListener('load', addHubspotForm);
    };
  }, [portalId, formId]);

  return (
    <div>
      <div id="hubspotForm"></div>
    </div>
  );
};

export default HubspotContactForm;
